import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import s from './FooterCopyright.scss';

export interface Props {
  className?: string;
}

const FooterCopyright: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <div className={classnames(s['root'], className)}>
      <div>
        {t('siteFooter.copyright', {
          year: new Date().getFullYear(),
        })}
      </div>
      <div className={s['separator']} />
      <div>{t('siteFooter.allRightsReserved')}</div>
    </div>
  );
};
FooterCopyright.displayName = 'FooterCopyright';

export default React.memo(FooterCopyright);
